"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Star = void 0;
var react_1 = __importDefault(require("react"));
exports.Star = function (props) {
    var cx = props.cx, cy = props.cy, stroke = props.stroke;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", __assign({ x: cx - 28, y: cy - 28, width: 900, height: 900 }, { fill: stroke, opacity: 0.3 }, { viewBox: '0 0 1024 1024', className: 'hover-shape' }),
            react_1.default.createElement(StarSvgPath, null)),
        react_1.default.createElement("svg", __assign({ x: cx - 15, y: cy - 15, width: 480, height: 480 }, { fill: stroke }, { viewBox: '0 0 1024 1024' }),
            react_1.default.createElement(StarSvgPath, null))));
};
var StarSvgPath = function () { return react_1.default.createElement("path", { d: 'M36 26 L32 16 L28 26 L16 26 L26 34 L20 46 L32 40 L44 46 L38 34 L48 26 Z' }); };
//# sourceMappingURL=Star.js.map